export default "/img/GW.447af606b36bbf2fd4765e29279158b2.png";